(function () {
  const HIDDEN_KEYS = ['screenshot'];

  function shouldHide(text) {
    if (!text) return false;
    const key = text.replace(/:\s*$/, '').trim().toLowerCase();
    return HIDDEN_KEYS.includes(key);
  }

  function hideIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.product-option').forEach((el) => {
      const dt = el.querySelector('dt');
      if (dt && shouldHide(dt.textContent)) el.style.display = 'none';
    });
  }

  function run() {
    hideIn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hideIn(node);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
